export default __webpack_public_path__ + "static/media/ic_gmx_big.b8dfece7.svg";